<template>
  <section
    id="pricing"
    class="px-3"
  >
    <section-header
      header=""
      sub-header="Paquetes"
      text=""
    />

    <v-container
      mt-5
      pa-0
    >
      <v-row>
        <v-col
          cols="12"
          class="text-center mb-5"
        >
          <v-btn-toggle
            v-model="frequency"
            rounded
          >
           
          </v-btn-toggle>
        </v-col>
        <v-col
          v-for="(plan, i) in plans"
          :key="i"
          cols="12"
          md="4"
        >
          <v-card
            :elevation="i === 1 ? 12 : 0"
            :outlined="i !== 1"
            class="v-card--plan text-center pb-3"
          >
            <v-toolbar
              color="grey lighten-5"
              flat
            >
              <v-spacer />
              <div v-text="plan.name"  class="display-1"/>
              <v-spacer />
            </v-toolbar>

            <v-card-text class="mb-4">
              <div
                v-for="(feature, j) in plan.features"
                :key="j"
                v-text="feature"
                class="headline"
              />
            </v-card-text>
            <v-card-text>
              <v-btn
                :color="i === 1 ? 'success' : 'primary'"
                depressed
                tile
                :href="plan.boton"
                target="_blank"
              >
                Solicitar
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {
    data: () => ({
      frequency: 0,
      plans: [
        {
          name: 'Básico',
          monthly: 750,
          boton: 'https://api.whatsapp.com/send?phone=522214191449&text=%C2%A1Hola!' + ' quiero solicitar un paquete básico',
          features: [
            'Aspirado',
            'Desmanchado Profesional',
            'Limpieza Profunda con Equipo Profesional',
            'Secado Rápido'
          ]
        },
        {
          name: 'Ambiental',
          monthly: 900,
          boton: 'https://api.whatsapp.com/send?phone=522214191449&text=%C2%A1Hola!' + ' quiero solicitar un paquete ambiental',
          features: [
            'Aspirado',
            'Desmanchado Profesional',
            'Limpieza Profunda con Equipo Profesional',
            'Secado Rápido',
            'Desinfección Activa'
          ]
        },
        {
          name: 'Elite',
          monthly: '1,659',
          boton: 'https://api.whatsapp.com/send?phone=522214191449&text=%C2%A1Hola!' + ' quiero solicitar un paquete élite',
          features: [
            'Aspirado',
            'Desmanchado Profesional',
            'Limpieza Profunda con Equipo Profesional',
            'Secado Rápido',
            'Desinfección Activa',
            'Aplicación de Protector'

          ]
        }
      ]
    })
  }
</script>

<style lang="sass">
  .v-card--plan
    &__price
      div
        vertical-align: text-bottom

        > sup
          vertical-align: super

        > span
          vertical-align: middle

        + span
          vertical-align: super
</style>
